module.exports = __webpack_public_path__ + "img/keyboard1.0ee771b6.png";